import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getSecondAnalyses,
  getSecondAnalysis,
  createSecondAnalysis,
  clearLocalSecondAnalyses,
  clearLocalActiveSecondAnalysis
} from './actions';

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  secondAnalysis: { id: '', input: null, document: null, result: null, status: '', updated_at: '' },
  loading: { all: false, secondAnalysis: false }
};

const slice = createSlice({
  name: 'secondAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSecondAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSecondAnalyses.fulfilled, (state, action) => {
        const { second_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...second_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getSecondAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSecondAnalysis.pending, (state) => {
        state.loading.secondAnalysis = true;
      })
      .addCase(getSecondAnalysis.fulfilled, (state, action) => {
        const { data: { second_analysis }, cable } = action.payload;
        const foundedSecondAnalysis = !!_find(state.all.data, (s) => s.id === second_analysis.id);
        const updatedSecondAnalysis = { ...state.secondAnalysis, ...second_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSecondAnalysis ? _map(state.all.data, (e) => e.id === second_analysis.id ? { ...e, ...second_analysis } : e) : [...[second_analysis], ...oldAllData]; 
        const pagination = foundedSecondAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.secondAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSecondAnalysis && !cable) state.secondAnalysis = updatedSecondAnalysis;       
      })
      .addCase(getSecondAnalysis.rejected, (state) => {
        state.loading.secondAnalysis = false;
      })
      .addCase(createSecondAnalysis.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(createSecondAnalysis.fulfilled, (state, action) => {
        const { second_analysis } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[second_analysis], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.all = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.secondAnalysis = second_analysis;  
      })
      .addCase(createSecondAnalysis.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(clearLocalSecondAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSecondAnalysis, state => {
        state.secondAnalysis = initialState.secondAnalysis;
      })
  }
})

export default slice.reducer;